export const drawArrow = (p5, base, vec, h, p) => {
  p5.push();
  p5.stroke(0);
  p5.strokeWeight(.5)
  p5.fill(0);
  p5.translate(base.x, base.y);
  p5.line(0, 0, vec.x, vec.y);
  p5.rotate(vec.heading());

  let arrowSize = 7;
  p5.translate(arrowSize, 0);
  p5.triangle(10, -arrowSize / 2, 10, arrowSize / 2, -arrowSize + 1, 0);
  p5.translate(vec.mag() - arrowSize * 2, 0);
  p5.triangle(-10, arrowSize / 2, -10, -arrowSize / 2, arrowSize - 1, 0);
  p5.pop();

  p5.push();
  p5.translate(base.x + vec.x / 2, base.y + vec.y / 2);
  p5.rectMode(p5.CENTER);
  p5.noStroke();
  // p5.rect(0, 0, 7 * p, 4 * p);
  p5.textSize(100 / p);
  p5.textAlign(p5.CENTER, p5.CENTER);
  p5.stroke('white')
  p5.strokeWeight(4)
  p5.text(`${h / p}"`, 0, 0);
  p5.pop();
};